import { useNavigate } from "react-router-dom";

import type { DashboardFlightRow } from "@/types/api";

type Column =
  | "session"
  | "date"
  | "duration"
  | "distance"
  | "avg_speed"
  | "smoothness"
  | "status";

interface FlightTableProps {
  rows: DashboardFlightRow[];
  columns: Column[];
  isInstructor?: boolean;
}

export function FlightTable({
  rows,
  columns,
  isInstructor = false,
}: FlightTableProps) {
  const navigate = useNavigate();

  return (
    <div className="table-shell">
      <table className="data-table">
        <thead>
          <tr>
            {columns.map((col) => {
              switch (col) {
                case "session":
                  return <th key={col}>Session</th>;
                case "date":
                  return <th key={col}>Date</th>;
                case "duration":
                  return <th key={col}>Duration</th>;
                case "distance":
                  return <th key={col}>Distance</th>;
                case "avg_speed":
                  return <th key={col}>Avg speed</th>;
                case "smoothness":
                  return <th key={col}>Smoothness score</th>;
                case "status":
                  return <th key={col}>Status</th>;
                default:
                  return null;
              }
            })}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => {
            const href = `/flights/${row.id}`;
            return (
              <tr
                key={row.id}
                className="clickable-row"
                onClick={(e) => {
                  if ((e.target as HTMLElement).closest("a, button")) return;
                  navigate(href);
                }}
              >
                {columns.map((col) => {
                  switch (col) {
                    case "session":
                      return (
                        <td key={col}>
                          <strong>{row.session_name ?? "—"}</strong>
                          {row.map_name && <small>{row.map_name}</small>}
                          {isInstructor && row.owner_label && (
                            <span className="flight-owner-badge">
                              {row.owner_label}
                            </span>
                          )}
                        </td>
                      );
                    case "date":
                      return (
                        <td key={col}>
                          <strong>{row.date_display}</strong>
                          {row.time_window_display && (
                            <small>{row.time_window_display}</small>
                          )}
                        </td>
                      );
                    case "duration":
                      return <td key={col}>{row.duration_display}</td>;
                    case "distance":
                      return <td key={col}>{row.distance_display}</td>;
                    case "avg_speed":
                      return <td key={col}>{row.avg_speed_display}</td>;
                    case "smoothness":
                      return <td key={col}>{row.smoothness_display}</td>;
                    case "status":
                      return (
                        <td key={col}>
                          <span className={`status-pill ${row.status}`}>
                            {row.status_label}
                          </span>
                        </td>
                      );
                    default:
                      return null;
                  }
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
